import { useEffect } from 'react';

import { useFeatureGate } from '@trello/feature-gate-client';
import { useGpuAcceleratedFeatures } from '@trello/gpu';

const BLUR_CLASS = 'overlay-blur';

export const useDialogEffect = () => {
  const { value: isOverlayBlurFlagEnabled } = useFeatureGate(
    'trello_personal_productivity_release',
  );

  const isGpuAcceleratedFeaturesEnabled = useGpuAcceleratedFeatures();

  const isBlurEnabled =
    isOverlayBlurFlagEnabled && isGpuAcceleratedFeaturesEnabled;

  useEffect(() => {
    const hasBlurClass = document.body.classList.contains(BLUR_CLASS);

    if (isBlurEnabled && !hasBlurClass) {
      document.body.classList.add(BLUR_CLASS);
    } else if (!isBlurEnabled && hasBlurClass) {
      document.body.classList.remove(BLUR_CLASS);
    }
  }, [isBlurEnabled]);
};
